/**
 * Sensor Style01 - Generic sensor value display (read-only)
 */
import type { TraitControlProps } from './types'

export function SensorStyle01({ state }: TraitControlProps) {
  const value =
    state?.value ??
    state?.thermostatTemperatureAmbient ??
    state?.temperature ??
    state?.temp ??
    state?.reading ??
    state?.level ??
    '--'
  const unit = (state?.unit as string) ?? (state?.thermostatTemperatureAmbient != null || state?.temperature != null ? '°C' : '')
  const label =
    (state?.sensorType ?? state?.type ?? (state?.thermostatTemperatureAmbient != null ? 'thermostatTemperatureAmbient' : state?.temperature != null ? 'Temperature' : 'Sensor')) as string

  return (
    <div
      className="smart-home-automation-field"
      data-css-slot="sensorContainer"
      data-css-slot-label="Sensor Container"
    >
      <label data-css-slot="sensorLabel" data-css-slot-label="Sensor Label">
        {label}
      </label>
      <div className="smart-home-automation-command-row">
        <span
          className="material-symbols-outlined"
          data-css-slot="sensorIcon"
          data-css-slot-label="Sensor Icon"
        >
          sensors
        </span>
        <span className="trait-sensor-style01__value" data-css-slot="sensorValue" data-css-slot-label="Sensor Value">
          {String(value)}
          {unit ? (
            <span data-css-slot="sensorUnit" data-css-slot-label="Sensor Unit">
              {' '}
              {unit}
            </span>
          ) : null}
        </span>
      </div>
    </div>
  )
}
